import { render, staticRenderFns } from "./table-chart.vue?vue&type=template&id=53ea69d6"
import script from "./table-chart.vue?vue&type=script&lang=js"
export * from "./table-chart.vue?vue&type=script&lang=js"
import style0 from "./table-chart.vue?vue&type=style&index=0&id=53ea69d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports